import PropTypes from 'prop-types';
import React from 'react';
import NameFields from 'react/shared/components/true_link/lab/form/NameFields';
import TrueLinkMaskedTextInput from 'react/shared/components/true_link/lab/form/TrueLinkMaskedTextInput';
import AddressFields from 'react/shared/components/true_link/lab/form/address_input/AddressFields';
import CountryOfCitizenship from 'react/shared/components/true_link/lab/form/country_of_citizenship/CountryOfCitizenship';
import ReferralDropdown from 'react/signups/card/common/ReferralDropdown';
import addressShape from 'react/signups/card/shapes/AddressShape';

export default function MyselfForm({ onChange, setFieldTouched, setValues, values }) {
  const countryOfCitizenshipLabel = 'Country of Citizenship';
  const nonResidentAlienLabel = 'Are you a non-resident alien?';

  return (
    <>
      <NameFields onChange={onChange} setFieldTouched={setFieldTouched} values={values} />
      <AddressFields
        labelPrefix="Home"
        setFieldTouched={setFieldTouched}
        setValues={setValues}
        values={values}
      />
      <CountryOfCitizenship
        countryOfCitizenshipLabel={countryOfCitizenshipLabel}
        nonResidentAlienLabel={nonResidentAlienLabel}
        onChange={onChange}
        required
        setFieldTouched={setFieldTouched}
        values={values}
      />
      <TrueLinkMaskedTextInput
        labelText="Phone number"
        mask="999-999-9999"
        name="mobile"
        onChange={onChange}
        placeholder="555-555-5555"
        required
        setFieldTouched={setFieldTouched}
        value={values.mobile}
      />
      <ReferralDropdown onChange={onChange} setFieldTouched={setFieldTouched} values={values} />
    </>
  );
}

MyselfForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.shape({
    address: addressShape,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
    referralCategory: PropTypes.string.isRequired,
    referralCategoryDetail: PropTypes.string.isRequired,
    referralName: PropTypes.string.isRequired,
  }).isRequired,
};
